/**
 * O que faz: Link estático do bloco de atendimento do dashboard para a análise de conversas.
 * Onde usa: Dashboard, na linha do período ao lado de "Atualizar" (antes ficava acima do card de tempo de resposta).
 * Conexões: Rota /analises/conversas (carregada sob demanda); em modo admin repassa a clínica pela URL.
 * Tabelas: Nenhuma; o link não consulta dados nem pré-carrega a página.
 * Data: 25/09/2026.
 */
import { Link } from 'react-router-dom';
import { MessagesSquare } from 'lucide-react';

interface LinkAnaliseConversasProps {
  // Presente só no modo admin; a página revalida no servidor se o admin pode ver essa clínica.
  adminClinicId?: string;
}

export function LinkAnaliseConversas({ adminClinicId }: LinkAnaliseConversasProps) {
  // Monta a busca manualmente: URLSearchParams.size não existe em todos os navegadores suportados.
  const parametros = new URLSearchParams();
  if (adminClinicId) parametros.set('adminClinicId', adminClinicId);
  const buscaSerializada = parametros.toString();
  const busca = buscaSerializada ? `?${buscaSerializada}` : '';

  return (
    <Link
      to={`/analises/conversas${busca}`}
      className="inline-flex h-9 items-center gap-1.5 rounded-full border border-border bg-card px-3.5 text-[13px] font-medium text-foreground transition-colors hover:border-[#c4cdbb] hover:bg-accent/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring motion-reduce:transition-none"
    >
      <MessagesSquare className="h-3.5 w-3.5" aria-hidden="true" />
      Analisar conversas
    </Link>
  );
}
